import React from 'react';
import usePageVisibility from '../usePageVisibility';
import {v4} from 'uuid';

export const CartStateContext = React.createContext([]);
export const CartDispatchContext = React.createContext(() => {});

const reducer = (state, action) => {
    switch (action.type) {
        case 'add':
            return [{quantity: 1, key: v4(), ...action.payload}, ...state];
        case 'increment':
            return state.map((entry) => {
                if (entry.key !== action.payload) return entry;
                return {...entry, quantity: entry.quantity + 1};
            });
        case 'decrement':
            return state.map((entry) => {
                if (entry.key !== action.payload) return entry;
                return {...entry, quantity: entry.quantity > 1 ? entry.quantity - 1 : entry.quantity};
            });
        case 'reduceQuantity':
            return state.map((entry) => {
                if (entry.key !== action.payload.entry) return entry;
                return {...entry, quantity: entry.quantity - action.payload.reduceBy};
            }).filter(e => e.quantity > 0);
        case 'remove':
            return state.filter((entry) => entry.key !== action.payload);
        case 'bulkRemove':
            return state.filter((entry) => !action.payload.includes(entry.key));
        case 'reset':
            return action.payload;
        default: throw new Error();
    }
};

const cart__ = 'cart__1';
const deserialize = () => window.localStorage.getItem(cart__) && JSON.parse(window.localStorage.getItem(cart__)) || [];
const serialize = (cart) => window.localStorage.setItem(cart__, JSON.stringify(cart));

export const CartProvider = React.memo(({children}) => {
    const [state, setState] = React.useState(() => deserialize());
    const onVisibilityChange = React.useCallback((visible) => {
        if (visible) {
            setState(e => reducer(e, {type: 'reset', payload: deserialize()}));
        }
    }, []);
    usePageVisibility(onVisibilityChange);
    const dispatch = React.useCallback((action) => {
        setState(e => {
            const nextState = reducer(e, action);
            serialize(nextState);
            return nextState;
        });
    }, []);
    return (
        <CartStateContext.Provider value={state}>
            <CartDispatchContext.Provider value={dispatch}>
                {children}
            </CartDispatchContext.Provider>
        </CartStateContext.Provider>
    );
});

export const useCartState = () => React.useContext(CartStateContext);
export const useCartDispatch = () => React.useContext(CartDispatchContext);
